import {IconWithLabel} from '@hconnect/common/components'
import {type EventType} from '@hconnect/common/types'
import {
  AssignmentOutlined,
  ChangeCircleOutlined,
  FlashOn,
  InfoOutlined,
  LocalHospital,
  Spa,
  Tune,
  Warning,
  WorkspacePremium,
  InsertInvitationOutlined,
  WbIncandescentOutlined,
  VisibilityOutlined
} from '@mui/icons-material'
import {SxProps, Theme} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {COMMON_SHIFT_EVENT_WIDGET_NAMESPACE} from '../consts'

export const eventTypeIcons: Record<EventType | 'stoppage' | 'unplannedStoppage', React.ReactNode> =
  {
    malfunction: <Warning />,
    task: <AssignmentOutlined />,
    information: <InfoOutlined />,
    idea: <WbIncandescentOutlined sx={{transform: 'rotate(180deg)'}} />,
    healthAndSafety: <LocalHospital />,
    environment: <Spa />,
    parameterChange: <Tune />,
    systemChangeRequest: <ChangeCircleOutlined />,
    incident: <FlashOn />,
    circumstance: <FlashOn />,
    plannedStoppage: <InsertInvitationOutlined />,
    stoppage: <FlashOn />,
    unplannedStoppage: <FlashOn />,
    quality: <WorkspacePremium />,
    spot: <VisibilityOutlined />,
    other: null
  }

export const EventTypeLabel: React.FC<{
  eventType: string
  iconOnly?: boolean
  eventTypeLabelPrefix?: string
  sx?: SxProps<Theme>
  'data-test-id'?: string
}> = (props) => {
  const {t} = useTranslation(COMMON_SHIFT_EVENT_WIDGET_NAMESPACE)

  return (
    <IconWithLabel
      sx={props.sx}
      icon={eventTypeIcons[props.eventType]}
      iconOnly={props.iconOnly}
      label={`${props.eventTypeLabelPrefix ? `${props.eventTypeLabelPrefix} ` : ''}${t(`shiftEvent.eventType.${props.eventType}`)}`}
      data-test-id={props['data-test-id']}
    />
  )
}
